import { Grid, Typography } from '@mui/material';

const InsuranceLogoGrid = () => (
  <Grid container rowSpacing={2} sx={{ mt: 0, mb: 4 }}>
    <Grid item xs={4} sx={{ textAlign: 'center' }}>
      <img
        src="/insurance-logos/bluecross-blueshield.svg"
        alt="Bluecross Blueshield insurance icon"
        style={{ width: '85px' }}
      />
    </Grid>
    <Grid item xs={4} sx={{ textAlign: 'center' }}>
      <img
        src="/insurance-logos/optum.svg"
        alt="Optum insurance icon"
        style={{ width: '85px' }}
      />
    </Grid>
    <Grid item xs={4} sx={{ textAlign: 'center' }}>
      <img
        src="/insurance-logos/united-healthcare.svg"
        alt="United Healthcare insurance icon"
        style={{ width: '85px' }}
      />
    </Grid>
    <Grid item xs={4} sx={{ textAlign: 'center' }}>
      <img
        src="/insurance-logos/aetna.svg"
        alt="Aetna insurance icon"
        style={{ width: '85px' }}
      />
    </Grid>
    <Grid item xs={4} sx={{ textAlign: 'center' }}>
      <img
        src="/insurance-logos/cigna.svg"
        alt="Cigna insurance icon"
        style={{ width: '85px' }}
      />
    </Grid>
    <Grid item xs={4} sx={{ textAlign: 'center' }}>
      <Typography style={{ color: 'info.main' }}>And more...</Typography>
    </Grid>
  </Grid>
);

export default InsuranceLogoGrid;
